// src/utils/resumeTemplate.ts
// Professional Resume Template Generator

export const generateResumeTemplate = (fullName: string = "Your Name", email: string = "your.email@example.com", phone: string = "(123) 456-7890"): string => {
  return `${fullName}
${email} | ${phone}

PROFESSIONAL SUMMARY
Results-driven professional with strong background in problem-solving and team collaboration. Seeking opportunities to leverage skills in a dynamic environment.

EXPERIENCE

Job Title
Company Name | City, Country | Month Year – Present
• Accomplished specific achievement with quantifiable result (e.g., increased efficiency by 30%)
• Led initiative resulting in measurable impact (e.g., saved company $50K annually)
• Collaborated with cross-functional team to deliver project on time and under budget

Job Title
Company Name | City, Country | Month Year – Month Year
• Managed team of X people to achieve quarterly targets
• Developed process/system that improved operational efficiency
• Successfully launched product/initiative with positive market response

EDUCATION

Degree Name (e.g., Bachelor of Science in Computer Science)
University Name | City, Country | Graduation: Month Year
GPA: X.XX (if 3.5 or higher)

SKILLS

Technical Skills: List relevant skills (e.g., Python, JavaScript, React, Project Management)
Soft Skills: Leadership, Communication, Problem-Solving, Team Collaboration
Tools & Platforms: List relevant tools (e.g., Jira, Git, Figma)

CERTIFICATIONS & ACHIEVEMENTS

• Professional Certification Name – Issuing Organization | Year
• Award or Recognition – Organization | Year
• Notable Achievement – Description | Year

ADDITIONAL INFORMATION

Languages: List any languages you speak (e.g., English - Native, Spanish - Fluent)
Volunteer Work: Relevant volunteer positions or community service (optional)`;
};

export const downloadResumeTemplate = (fullName: string = "Your Name", email: string = "your.email@example.com", phone: string = "(123) 456-7890") => {
  const templateText = generateResumeTemplate(fullName, email, phone);
  const element = document.createElement("a");
  const file = new Blob([templateText], { type: "text/plain" });
  element.href = URL.createObjectURL(file);
  element.download = "Resume_Template.txt";
  document.body.appendChild(element);
  element.click();
  document.body.removeChild(element);
};

export const viewResumeTemplate = (fullName: string = "Your Name", email: string = "your.email@example.com", phone: string = "(123) 456-7890"): string => {
  return generateResumeTemplate(fullName, email, phone);
};
